import { useRef } from 'react';

const CHART_H = 120;

function barColor(w) {
  if (w >= 12) return 'var(--signal)';
  if (w <= 3)  return 'var(--bar-low)';
  return 'var(--bar-mid)';
}

export default function DraggableBar({ index, weight, onWeightChange }) {
  const startRef = useRef(null);
  const barH = weight === 0 ? 0 : Math.max(4, (weight / 20) * (CHART_H - 4));

  function startDrag(clientY) {
    startRef.current = { y: clientY, w: weight };

    const onMouseMove = (e) => {
      const delta = startRef.current.y - e.clientY;
      const newW = Math.max(0, Math.min(20, startRef.current.w + delta * 0.12));
      onWeightChange(index, newW);
    };
    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
    const onTouchMove = (e) => {
      e.preventDefault();
      const delta = startRef.current.y - e.touches[0].clientY;
      const newW = Math.max(0, Math.min(20, startRef.current.w + delta * 0.12));
      onWeightChange(index, newW);
    };
    const onTouchEnd = () => {
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd);
  }

  return (
    <div
      onMouseDown={(e) => { e.preventDefault(); startDrag(e.clientY); }}
      onTouchStart={(e) => startDrag(e.touches[0].clientY)}
      style={{
        flex: 1, display: 'flex', alignItems: 'flex-end',
        height: CHART_H, cursor: 'ns-resize',
        userSelect: 'none', touchAction: 'none',
        padding: '0 1px',
      }}
    >
      <div style={{
        width: '100%', height: barH,
        backgroundColor: barColor(weight),
        borderRadius: '3px 3px 0 0',
        transition: 'background-color 0.15s',
      }} />
    </div>
  );
}
